import { render, staticRenderFns } from "./CieloSettings.vue?vue&type=template&id=ba325976"
import script from "./CieloSettings.vue?vue&type=script&lang=js"
export * from "./CieloSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports